import { styled } from "@mui/material/styles";
import Script from "next/script";

import type { ExternalWidgetRezdy as ExternalWidgetRezdyType } from "../../types/ExternalWidget";

export type ExternalWidgetRezdyProps = Omit<ExternalWidgetRezdyType, "__typename">;

const Iframe = styled("iframe")({
    height: 1000,
    border: 0,
});

export function ExternalWidgetRezdy({ widgetId, height, slug }: ExternalWidgetRezdyProps) {
    const src = `https://${slug}.rezdy.com/calendarWidget/${widgetId}?iframe=true`;
    return (
        <>
            <Script id="external-widget-rezdy" src={`https://${slug}.rezdy.com/pluginJs`} />
            <Iframe width="100%" height={height ?? "100%"} src={src} />
        </>
    );
}
